<app-skeleton class="edit-template-rightSec-loader" *ngIf="generalpopup" [section]="'edit_template_rightmenu'" [loop]="0"></app-skeleton>
<ng-container *transloco="let t;">
<div  *ngIf="!generalpopup">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center content-sidebar-header py-75 px-1 mt-50">
        <div class="cursor-pointer" *ngIf="data['isFormBuilder'] === 1" (click)="backToFormBuilder()">
            <i data-feather="arrow-left" [size]="16" class="ms-0"></i>
        </div>
        <div class="linked-organization-inner">
            <div class="d-flex justify-content-start align-items-center">
                <div class="user-page-info">
                    <h5 class="mb-0">
                        {{data['selected_field'] | translateField}} 
                    </h5>
                </div>
            </div>
        </div>
        <div class="cursor-pointer closeMenu" (click)="close()">
            <i data-feather="x" [size]="16" class="ms-0"></i>
        </div>
    </div>

    <!-- Text || Datepikcer Field Settings View -->
    <div id="textFieldBox" *ngIf="data['selected_field'] === SelectedFieldEnum.TextField || data['selected_field'] === SelectedFieldEnum.DatepickerField">
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="fieldsSettings-scroll-content-container">
            <div class="">
                <div class="form-group px-1">
                    <label class="col-form-label pt-0" for="name">{{t("Field settings tield type (Template/Document - section) - Field type")}}</label>
                    <div class="custum-dropdown-field-type" >
                        <!-- Select with custom Option -->
                        <ng-select #field_type
                        bindLabel="name" bindValue="prefixid" [(ngModel)]="fieldSelectedType" [items]="fieldtype" [readonly]="readonly" [searchable]="true" [placeholder]='t("Field settings select field type (Template/Document - section) - Select field type")' [clearable]="false" (change)="onSelectTypeChange($event)"
                        >
                            <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="ng-value-label field-type-value">{{ item.name }}</span>
                                    <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.field_type }}</span>
                                </div>
                                   
                            </ng-template>
                        </ng-select>
                        <label class="col-form-label col-form-label-font pt-75" for="name" *ngIf="field_info === 'me' && fieldSelectedType !== '0'">{{t("Field settings auto populate value (Template/Document - section) - The value is auto populated from senders profile")}}</label>
                        <span class="d-flex justify-content-end align-items-center">
                            <button *ngIf="showLabel === '0'" (click)="saveToMetaData(data['selected_field'])" type="button" class="btn p-0 btn-sm text-success btn-transparent mt-75">{{t("Field settings Save to meta data (Template/Document - section) - Save to meta data")}}</button>
                        </span>
                        <!--/ Select with custom Option -->
                    </div>
                </div>
                <div class="form-group px-1">
                    <label class="col-form-label pt-0" for="basicInput">{{t("Field settings Rename name label (Template/Document - section) - Label")}}</label>
                    <input #label type="text" class="form-control" id="basicInput" [placeholder]="labelName" [value]="labelName"
                        (keyup)="renameLabel($event)" />
                </div>
                <div class="form-group px-1">
                    <label class="col-form-label pt-0" for="basicInput">{{t("Field settings Rename placeholder label (Template/Document - section) - Placeholder")}}</label>
                    <input type="text" class="form-control" id="basicInput" [placeholder]="" [value]="placeholderName"
                        (keyup)="renamePlaceholder($event)" />
                </div>
                <hr class="mt-2 mb-2">
                <div class="form-group d-flex justify-content-between align-items-center px-1">
                    <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field is Required (Template/Document - section) - Required")}}</label>
                    <div class="custom-control custom-control-primary custom-switch ">
                        <input type="checkbox" [checked]="isRequired" class="custom-control-input" id="customSwitch3"
                            (change)="onRequiredChange($event)" />
                        <label class="custom-control-label" for="customSwitch3"></label>
                    </div>
                </div>
                <ng-container  *ngTemplateOutlet="lockCheckbox; context: { isLocked: isLocked }"></ng-container>
                <hr class="mt-2 mb-1" *ngIf="isTagView === 0">
    
                <div class="form-group px-1" *ngIf="(field_info !== 'me' || fieldSelectedType === '0') && field_info !== 'recipient_field'">
                    <label class="col-form-label pt-0" for="name">{{t("Field settings Role fill field (Template/Document - setion) - Which role will fill this field")}}</label>
                    <div class="custum-dropdown-field-type" >
                        <ng-select #roleSelecter [items]="selectRole" bindLabel="name" bindValue="id" [(ngModel)]="selectedRole" [readonly]="readonly"
                        [searchable]="searchable" [placeholder]='t("Field settings Select role - placeholder (Template/Document - section) - Select role")' [clearable]="false" (change)="onChangeRoleType($event)">
                            <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <div>
                                    <div class="">
                                        <span class="">{{ item.name }}</span>
                                        <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.recipient }}</span>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
    
                <div class="form-group px-1" *ngIf="isTagView === 0">
                    <label class="col-form-label pt-0" for="name">{{t("Field settings Field font size (Template/Document - section) - Font size")}}</label>
                    <ng-select [items]="selectFontSize" #select_selectFontSize bindLabel="name" [(ngModel)]="selectedFontSize" [readonly]="readonly"
                        [searchable]="searchable"  (change)="changeFontSize($event)" [clearable]="false">
                    </ng-select>
                </div>
    
                <div class="form-group px-1" *ngIf="data['isFormBuilder'] === 1 && isTagView === 0">
                    <label class="col-form-label pt-0" for="name">{{t("Field settings Field column size (Template/Document - section) - Column size")}}</label>
                    <ng-select [items]="selectColumnSize" bindLabel="name" bindValue="id" [(ngModel)]="selectedColumnSize" [readonly]="readonly"
                        [searchable]="searchable" [placeholder]='t("Field settings Select column size (Template/Document - section) - Select column size")' (change)="changeColumnSize($event)" [clearable]="false">
                    </ng-select>
                </div>
    
                <!-- <hr class="mt-2 mb-1"> -->
    
                <div class="form-group px-1" *ngIf="!slashCommandTable && isTagView === 0 && fieldBlock === '0'">
                    <label class="col-form-label pt-0" for="name">{{t("Field settings Field Style (Template/Document - section) - Field Style")}}</label>
                    <ng-select [items]="fields_style" [(ngModel)]="selectedFieldStyle" bindLabel="name" bindValue="name" (change)="selectFieldStyle(i,$event)" [clearable]="false" [clearable]="false">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="field-style-container">
                                <div class="field-style-box cursor-pointer">
                                    <div class="field-style {{item['class']}}">
                                        <span class="placeholder-field-label">{{item['name']}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
    
                <hr class="mt-2 mb-2" *ngIf="data['selected_field'] === SelectedFieldEnum.TextField">
    
                <div class="form-group d-flex justify-content-between align-items-center px-1" *ngIf="data['selected_field'] === SelectedFieldEnum.TextField">
                    <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Allow multiple rows (Template/Document - section) - Allow multiple rows")}}</label>
                    <div class="custom-control custom-control-primary custom-switch ">
                        <input type="checkbox" class="custom-control-input" id="customSwitch4" [checked]="isMultiLinesChecked"
                            (change)="allowMultiLines($event)" />
                        <label class="custom-control-label" for="customSwitch4"></label>
                    </div>
                </div>
    
                <hr class="mt-2 mb-2">
    
                <div class="form-group d-flex justify-content-between align-items-center px-1">
                    <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field Conditional (Template/Document - section) - Conditional")}}</label>
                    <div class="custom-control custom-control-primary custom-switch ">
                        <input type="checkbox" class="custom-control-input" id="Conditional" (change)="activeConditional($event)" [checked]="enable_conditional" />
                        <label class="custom-control-label" for="Conditional"></label>
                    </div>
                </div>
    
                <div class="form-group px-1 mt-1 conditional-dropdown" *ngIf="enable_conditional">
                    <div class="mt-1" >
                        <ng-select [compareWith]="selectedFeildFn" #conditional_fields_textField [closeOnSelect]="false" [multiple]="true" #roleSelecter [items]="conditional_fields" bindLabel="name" bindValue="uuid" [(ngModel)]="selectedConditioanl" [readonly]="readonly"
                        [searchable]="true" [placeholder]='t("Field settings Select field (Template/Document - section) - Select field")' [clearable]="false" (change)="onSelectRelations($event)">
                            <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm" let-clear="clear">
                                <div>
                                    <div class="d-flex">
                                        <div class="d-flex w-100 flex-column align-items-start justify-content-center">
                                            <span class="ng-value-label">{{ item.name }}</span>
                                            <span *ngIf="item.selected_field === SelectedFieldEnum.DroplistField || item.selected_field === SelectedFieldEnum.ListField" class="text-muted">({{item.field_name}})</span>
                                        </div>
                                        <span class="field-type-label">{{ item.role_name }}</span>
                                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                
                @if(data['selected_field'] === SelectedFieldEnum.TextField){
                    <hr class="mt-2 mb-2">
                    <app-calculation-fields [uuid]="data['uuid']"></app-calculation-fields>
                }
                <hr class="mt-2 mb-1">
    
                <div class="px-1 mt-2 mb-2">
                    <div class="cursor-pointer mt-50 text-danger d-flex align-items-center">
                        <i data-feather="trash" [size]="16" class="me-50"></i>
                        <span class="align-text-bottom line-height-1" (click)="deleteSettings()">{{t("Delete button text (delete button) - delete")}}</span>
                    </div>
                </div>
            </div>
        </ng-scrollbar>
    </div>
    <!-- / Text || Datepikcer Field Settings View -->

    <!-- Checkbox Settings View -->
    <div id="checkboxFieldBox" *ngIf="data['selected_field'] === SelectedFieldEnum.CheckboxField">
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="fieldsSettings-scroll-content-container">
        <div class="">
            <div class="form-group px-1">
                <label class="col-form-label pt-0" for="name">{{t(  "Field settings tield type (Template/Document - section) - Field type")}}</label>
                <div class="custum-dropdown-field-type" >
                    <!-- Select with custom Option -->
                    <ng-select #field_type
                    bindLabel="name" bindValue="prefixid" [(ngModel)]="fieldSelectedType" [items]="fieldtype" [readonly]="readonly" [searchable]="true" [placeholder]='t("Field settings select field type (Template/Document - section) - Select field type")' [clearable]="false" 
                    (change)="onSelectTypeChange($event)"
                    >
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="ng-value-label field-type-value">{{ item.name }}</span>
                                <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.field_type }}</span>                        
                            </div>
                        </ng-template>
                    </ng-select>
                    <label class="col-form-label pt-1" for="name" *ngIf="field_info === 'me' && fieldSelectedType !== '0'">{{t("Field settings auto populate value (Template/Document - section) - The value is auto populated from senders profile")}}</label>
                    <button *ngIf="showLabel === '0'" (click)="saveToMetaData(data['selected_field'])" type="button" class="btn p-0 btn-sm d-flex text-success btn-transparent float-end mt-75">{{t("Field settings Save to meta data (Template/Document - section) - Save to meta data")}}</button>
                    <!--/ Select with custom Option -->
                </div>
            </div>
            <div class="form-group px-1">
                <label #label class="col-form-label pt-0" for="basicInput">{{t("Field settings Rename name label (Template/Document - section) - Label")}}</label>
                <input type="text" class="form-control" id="basicInput" [placeholder]="labelName" [value]="[labelName]"
                    (keyup)="renameLabel($event)" />
            </div>
            <hr class="mt-2 mb-2">

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Checkbox pre-checked (Template/Document - section) - Pre-checked")}}?</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" [checked]="isPreChecked" class="custom-control-input" id="checkBoxPreChecked"
                        (change)="onPreCheckedChange($event)" />
                    <label class="custom-control-label" for="checkBoxPreChecked"></label>
                </div>
            </div>

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field is Required (Template/Document - section) - Required")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" [checked]="isRequired" class="custom-control-input" id="checkFieldRequired"
                        (change)="onRequiredChange($event)" />
                    <label class="custom-control-label" for="checkFieldRequired"></label>
                </div>
            </div>
            <ng-container  *ngTemplateOutlet="lockCheckbox; context: { isLocked: isLocked }"></ng-container>
            <hr class="mt-2 mb-1">

            <div class="form-group px-1 custum-dropdown-field-type">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Who should checked (Template/Document - section) - Who should check this box")}}?</label>
                <ng-select [items]="selectRole" bindLabel="name" bindValue="id" [(ngModel)]="selectedRole" [readonly]="readonly"
                    [searchable]="searchable" [placeholder]='t("Field settings Select role - placeholder (Template/Document - section) - Select role")' [clearable]="false" (change)="onChangeRoleType($event)">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                        
                            <div class="d-flex position-relative">
                                <span class="ng-value-label">{{ item.name }}</span>
                                <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.recipient }}</span>
                            </div>                                
                        </ng-template>
                    </ng-select>
            </div>

            <div class="form-group px-1" *ngIf="isTagView === 0">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Field font size (Template/Document - section) - Font size")}}</label>
                <ng-select [items]="selectFontSize" #select_selectFontSize bindLabel="name" [(ngModel)]="selectedFontSize" [readonly]="readonly"
                    [searchable]="searchable"  (change)="changeFontSize($event)" [clearable]="false">
                </ng-select>
            </div>
    
            <div class="form-group px-1" *ngIf="data['isFormBuilder'] === 1">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Field column size (Template/Document - section) - Column size")}}</label>
                <ng-select [items]="selectColumnSize" bindLabel="name" bindValue="id" [(ngModel)]="selectedColumnSize" [readonly]="readonly"
                    [searchable]="searchable" [placeholder]='t("Field settings Select column size (Template/Document - section) - Select column size")' (change)="changeColumnSize($event)" [clearable]="false">
                </ng-select>
            </div>
            
            <hr class="mt-2 mb-2">

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field Conditional (Template/Document - section) - Conditional")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" class="custom-control-input" id="Conditional" (change)="activeConditional($event)" [checked]="enable_conditional" />
                    <label class="custom-control-label" for="Conditional"></label>
                </div>
            </div>

            <div class="form-group px-1 mt-1 conditional-dropdown" *ngIf="enable_conditional">
                <div class="mt-1" >
                    <ng-select [compareWith]="selectedFeildFn" [closeOnSelect]="false" [multiple]="true" #roleSelecter [items]="conditional_fields" bindLabel="name" bindValue="uuid" [(ngModel)]="selectedConditioanl" [readonly]="readonly"
                    [searchable]="true" [placeholder]='t("Field settings select field type (Template/Document - section) - Select field type")' [clearable]="false" (change)="onSelectRelations($event)">
                        <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm" let-clear="clear">
                            <div>
                                <div class="d-flex">
                                    <div class="d-flex flex-column align-items-start justify-content-center w-100">
                                        <span class="ng-value-label">{{ item.name }}</span>
                                        <span *ngIf="item.selected_field === SelectedFieldEnum.DroplistField || item.selected_field === SelectedFieldEnum.ListField" class="text-muted">({{item.field_name}})</span>
                                    </div>
                                    <span class="field-type-label">{{ item.role_name }}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <hr class="mt-2 mb-1">

            <div class="px-1 mt-2 mb-2">
                <div class="cursor-pointer mt-50 text-danger d-flex align-items-center">
                    <i data-feather="trash" [size]="16" class="me-50"></i>
                    <span class="align-text-bottom line-height-1" (click)="deleteSettings()">{{t("Delete button text (delete button) - delete")}}</span>
                </div>
            </div>
        </div>
        </ng-scrollbar>
    </div>
    <!-- / Checkbox Settings View -->

    <!-- droplist Settings View -->
    <div id="droplistFieldBox" *ngIf="data['selected_field'] === SelectedFieldEnum.DroplistField">
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="fieldsSettings-scroll-content-container">
        <div>
            <div class="form-group px-1 mm custum-dropdown-field-type">
                <label class="col-form-label pt-0" for="name">{{t(  "Field settings tield type (Template/Document - section) - Field type")}}</label>
                <ng-select #field_type bindLabel="name" bindValue="prefixid" [(ngModel)]="fieldSelectedType"  [items]="fieldtype"
                    bindLabel="name" [readonly]="readonly" [searchable]="searchable" [placeholder]='t("Field settings select field type (Template/Document - section) - Select field type")' [clearable]="false" (change)="onDroplistTypeChange($event,'droplist')">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">                                
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="ng-value-label field-type-value">{{ item.name }}</span>
                                <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.field_type }}</span>
                            </div>
                        </ng-template>
                </ng-select>
                <button *ngIf="showLabel === '0'" (click)="saveToMetaData(data['selected_field'])" type="button" class="btn p-0 btn-sm d-flex text-success btn-transparent float-end mt-75">{{t("Field settings Save to meta data (Template/Document - section) - Save to meta data")}}</button>
            </div>
            <div class="form-group px-1">
                <label class="col-form-label pt-0" for="basicInput">{{t("Field settings Rename name label (Template/Document - section) - Label")}}</label>
                <input autofocus #label type="text" class="form-control" id="basicInput" [placeholder]="labelName" [value]="[labelName]"
                    (keyup)="renameLabel($event)" />
            </div>
            <div class="form-group px-1">
                <label class="col-form-label pt-0" for="basicInput">{{t("Field settings Rename placeholder label (Template/Document - section) - Placeholder")}}</label>
                <input type="text" class="form-control" id="basicInput" [placeholder]="" [value]="placeholderName"
                    (keyup)="renameDroplistPlaceholder($event)" />
            </div>
            <div class="px-1 mb-2" *ngIf="showLabel !== '0'">
                <div class="create-option-container test1">
                    <div class="input-group input-group-merge mb-1" *ngFor="let option of preAddMultiChoiceOption; let i = index">
                        @if(option.name){
                            <input type="text" class="form-control" value="{{option.name}}" disabled />
                            <div class="input-group-append">
                                <span *ngIf="!option.hide || option.hide === 0" class="input-group-text pe-50 ps-50" (click)="hideOption(1,i,option,'droplist')">
                                    <i class="cursor-pointer" data-feather="eye"></i>
                                </span>
                                <span *ngIf="option.hide && option.hide === 1" class="input-group-text pe-50 ps-50" (click)="hideOption(0,i,option,'droplist')">
                                    <i class="cursor-pointer" data-feather="eye-off"></i>
                                </span>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="px-1 mb-2" *ngIf="showLabel === '0'">
                <div class="create-option-container test">
                    <div class="input-group input-group-merge mb-1" *ngFor="let option of multiChoiceOption; let i = index">
                        <input type="text" class="form-control" value="{{option.name}}" (keyup)="renameOption($event,option,i,'droplist')" />
                        <div class="input-group-append">
                        <span *ngIf="!option.hide || option.hide === 0" class="input-group-text input-group-icon-eye pe-25 ps-25" (click)="hideOption(1,i,option,'droplist','default')">
                                <i class="cursor-pointer" data-feather="eye"></i>
                            </span>
                            <span *ngIf="option.hide && option.hide === 1" class="input-group-text input-group-icon-eye pe-25 ps-25" (click)="hideOption(0,i,option,'droplist','default')">
                                <i class="cursor-pointer" data-feather="eye-off"></i>
                            </span>
                            <span class="input-group-text pe-50 ps-50" (click)="deleteOption($event,option,i,'droplist')">
                                <i class="cursor-pointer" data-feather="trash"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <button (click)="addOption('droplist')" type="button" class="btn p-0 btn-sm d-flex text-success btn-transparent">{{t("Add button title (add button) - Add")}}</button>
            </div>

            <hr class="mt-2 mb-2">

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field is Required (Template/Document - section) - Required")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" [checked]="isRequired" class="custom-control-input" id="customSwitch3"
                        (change)="onRequiredChange($event)" />
                    <label class="custom-control-label" for="customSwitch3"></label>
                </div>
            </div>
            <ng-container  *ngTemplateOutlet="lockCheckbox; context: { isLocked: isLocked }"></ng-container>
            <!-- <hr class="mt-2 mb-1"> -->

            <div class="form-group px-1 custum-dropdown-field-type">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Who select this option (Template/Document - section) - Who select this option")}}?</label>
                <ng-select [items]="selectRole" bindLabel="name" bindValue="id" [(ngModel)]="selectedRole" [readonly]="readonly"
                    [searchable]="searchable" [placeholder]='t("Field settings Select role - placeholder (Template/Document - section) - Select role")' [clearable]="false" (change)="onChangeRoleType($event)">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div>
                                <div class="">
                                    <span class="">{{ item.name }}</span>
                                    <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.recipient }}</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
            </div>

            <div class="form-group px-1" *ngIf="isTagView === 0">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Field font size (Template/Document - section) - Font size")}}</label>
                <ng-select [items]="selectFontSize" #select_selectFontSize bindLabel="name" [(ngModel)]="selectedFontSize" [readonly]="readonly"
                    [searchable]="searchable" [clearable]="false" (change)="changeFontSize($event)"> </ng-select>
            </div>

            <div class="form-group px-1" *ngIf="data['isFormBuilder'] === 1">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Field column size (Template/Document - section) - Column size")}}</label>
                <ng-select [items]="selectColumnSize" bindLabel="name" bindValue="id" [(ngModel)]="selectedColumnSize" [readonly]="readonly"
                    [searchable]="searchable" [placeholder]='t("Field settings Select column size (Template/Document - section) - Select column size")' (change)="changeColumnSize($event)" [clearable]="false">
                </ng-select>
            </div>

            <hr class="mt-2 mb-2">

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field Conditional (Template/Document - section) - Conditional")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" class="custom-control-input" id="Conditional" (change)="activeConditional($event)" [checked]="enable_conditional" />
                    <label class="custom-control-label" for="Conditional"></label>
                </div>
            </div>

            <div class="form-group px-1 mt-1 conditional-dropdown" *ngIf="enable_conditional">
                <div class="mt-1" >
                    <ng-select [compareWith]="selectedFeildFn" [closeOnSelect]="false" [multiple]="true" #roleSelecter [items]="conditional_fields" bindLabel="name" bindValue="uuid" [(ngModel)]="selectedConditioanl" [readonly]="readonly"
                    [searchable]="true" [placeholder]='t("Field settings Select field (Template/Document - section) - Select field")' [clearable]="false" (change)="onSelectRelations($event)">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm" let-clear="clear">
                            <div>
                                <div class="d-flex">
                                    <div class="d-flex w-100 flex-column align-items-start justify-content-center">
                                        <span class="ng-value-label">{{ item.name }}</span>
                                        <span *ngIf="item.selected_field === SelectedFieldEnum.DroplistField || item.selected_field === SelectedFieldEnum.ListField" class="text-muted">({{item.field_name}})</span>
                                    </div>
                                    <span class="field-type-label">{{ item.role_name }}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <hr class="mt-2 mb-1">

            <div class="px-1 mt-2 mb-2">
                <div class="cursor-pointer mt-50 text-danger d-flex align-items-center">
                    <i data-feather="trash" [size]="16" class="me-50"></i>
                    <span class="align-text-bottom line-height-1" (click)="deleteSettings()">{{t("Delete button text (delete button) - delete")}}</span>
                </div>
            </div>
        </div>
        </ng-scrollbar>
    </div>
    <!-- / droplist Settings View -->


    <!-- signature Settings View -->
    <div id="signatureboxFieldBox" *ngIf="data['selected_field'] === SelectedFieldEnum.SignatureField">
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="signatureboxFieldBox-scroll-content-container">
        <div>

            <div class="form-group px-1" *ngIf="field_info !== 'me' || fieldSelectedType === '0'">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Who should sign here (Template/Document - section) - Who should sign here")}}?</label>
                <div class="custum-dropdown-field-type" >
                    <ng-select #roleSelecter [items]="selectRole" bindLabel="name" bindValue="id" [(ngModel)]="selectedRole" [readonly]="readonly"
                    [searchable]="searchable" [placeholder]='t("Field settings Select role - placeholder (Template/Document - section) - Select role")' [clearable]="false" (change)="onChangeRoleType($event)">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div *ngIf="item.id !== '-1'">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="ng-value-label field-type-value">{{ item.name }}</span>
                                    <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.recipient }}</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <ng-container  *ngTemplateOutlet="lockCheckbox; context: { isLocked: isLocked }"></ng-container>
            <div class="form-group px-1 mt-1">
                <div class="custom-control custom-checkbox">
                <input
                    type="checkbox"
                    [(ngModel)]="isLabelHide"
                    class="custom-control-input"
                    id="toggle-label"
                    (change)="toggleSignatureLabel($event)"
                />
                <label class="custom-control-label" for="toggle-label">{{t("Field settings Hide field label (Template/Document - section) - Hide label")}}</label>
                </div>
            </div>
            <hr class="mt-2 mb-2">

            <!-- Transparent (signature only) -->
            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="customSwitchTransparent">{{ t("Field settings Transparent label (Template/Document - section) - Transparent") }}</label>
                <div class="custom-control custom-control-primary custom-switch">
                    <input type="checkbox"
                        class="custom-control-input"
                        id="customSwitchTransparent"
                        [checked]="isTransparent"
                        (change)="transparentChange($event)" />
                    <label class="custom-control-label" for="customSwitchTransparent"></label>
                </div>
            </div>

            <hr class="mt-2 mb-2">

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field Conditional (Template/Document - section) - Conditional")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" class="custom-control-input" id="Conditional" (change)="activeConditional($event)" [checked]="enable_conditional" />
                    <label class="custom-control-label" for="Conditional"></label>
                </div>
            </div>

            <div class="form-group px-1 mt-1 conditional-dropdown" *ngIf="enable_conditional">
                <div class="mt-1" >
                    <ng-select [compareWith]="selectedFeildFn" [closeOnSelect]="false" [multiple]="true" #roleSelecter [items]="conditional_fields" bindLabel="name" bindValue="uuid" [(ngModel)]="selectedConditioanl" [readonly]="readonly"
                    [searchable]="true" [placeholder]='t("Field settings Select field (Template/Document - section) - Select field")' [clearable]="false" (change)="onSelectRelations($event)">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm" let-clear="clear">
                            <div>
                                <div class="d-flex justify-content-between align-items-start">
                                    <div class="d-flex w-100 flex-column align-items-start justify-content-center field-type-value">
                                        <span class="ng-value-label field-type-value">{{ item.name }}</span>
                                        <span *ngIf="item.selected_field === SelectedFieldEnum.DroplistField || item.selected_field === SelectedFieldEnum.ListField" class="text-muted">({{item.field_name}})</span>
                                    </div>
                                    <span class="field-type-label">{{ item.role_name }}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="px-1 mt-2 mb-2">
                <div class="cursor-pointer mt-50 text-danger d-flex align-items-center">
                    <i data-feather="trash" [size]="16" class="me-50"></i>
                    <span class="align-text-bottom line-height-1" (click)="deleteSettings()">{{t("Delete button text (delete button) - delete")}}</span>
                </div>
            </div>
        </div>
        </ng-scrollbar>
    </div>
    <!-- / signature Settings View -->

    <!-- Multi Choice Settings View -->
    <div id="multiChoiceFieldBox" *ngIf="data['selected_field'] === SelectedFieldEnum.ListField">
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="fieldsSettings-scroll-content-container">
        <div>
            <div class="form-group px-1 custum-dropdown-field-type">
                <label class="col-form-label pt-0" for="name">{{t("Field settings tield type (Template/Document - section) - Field type")}}</label>
                <ng-select #field_type bindLabel="name" bindValue="prefixid" [(ngModel)]="fieldSelectedType" [items]="fieldtype"
                    bindLabel="name" [readonly]="readonly" [searchable]="searchable" [placeholder]='t("Field settings select field type (Template/Document - section) - Select field type")' [clearable]="false" (change)="onDroplistTypeChange($event,'multichoice')">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="ng-value-label field-type-value">{{ item.name }}</span>
                                <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.field_type }}</span>
                            </div>
                        </ng-template>
                </ng-select>
                <button *ngIf="showLabel === '0'" (click)="saveToMetaData(data['selected_field'])" type="button" class="btn p-0 btn-sm d-flex text-success btn-transparent float-end mt-75">{{t("Field settings Save to meta data (Template/Document - section) - Save to meta data")}}</button>
            </div>
            <div class="form-group px-1">
                <label #label class="col-form-label pt-0" for="basicInput">{{t("Field settings Rename name label (Template/Document - section) - Label")}}</label>
                <input type="text" class="form-control" id="basicInput" [placeholder]="labelName" [value]="[labelName]" (keyup)="renameLabel($event)" />
            </div>
            <div class="px-1 mb-2" *ngIf="showLabel !== '0'">
                <div class="create-option-container">
                    <div class="input-group input-group-merge mb-1" *ngFor="let option of preAddMultiChoiceOption; let i = index">
                        @if(option.name){
                            <input type="text" class="form-control" value="{{option.name}}" disabled />
                            <div class="input-group-append">
                                <span *ngIf="!option.hide || option.hide === 0" class="input-group-text pe-50 ps-50" (click)="hideOption(1,i,option,'multichoice')">
                                    <i class="cursor-pointer" data-feather="eye"></i>
                                </span>
                                <span *ngIf="option.hide && option.hide === 1" class="input-group-text pe-50 ps-50" (click)="hideOption(0,i,option,'multichoice')">
                                    <i class="cursor-pointer" data-feather="eye-off"></i>
                                </span>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="px-1 mb-2" *ngIf="showLabel === '0'">
                <div class="create-option-container">
                    <div class="input-group input-group-merge mb-1" *ngFor="let option of multiChoiceOption; let i = index">
                        <input type="text" class="form-control" value="{{option.name}}" (keyup)="renameOption($event,option,i,'multichoice')" />
                        <div class="input-group-append">
                            <span *ngIf="!option.hide || option.hide === 0" class="input-group-text input-group-icon-eye pe-50 ps-25" (click)="hideOption(1,i,option,'multichoice','default')">
                                <i class="cursor-pointer" data-feather="eye"></i>
                            </span>
                            <span *ngIf="option.hide && option.hide === 1" class="input-group-text input-group-icon-eye pe-50 ps-25" (click)="hideOption(0,i,option,'multichoice','default')">
                                <i class="cursor-pointer" data-feather="eye-off"></i>
                            </span>
                            <span class="input-group-text pe-50 ps-50" (click)="deleteOption($event,option,i,'multichoice')">
                                <i class="cursor-pointer" data-feather="trash"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <button (click)="addOption('multichoice')" type="button" class="btn p-0 btn-sm d-flex text-success btn-transparent">{{t("Add button title (add button) - Add")}}</button>
            </div>

            <hr class="mt-2 mb-2">

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field is Required (Template/Document - section) - Required")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" [checked]="isRequired" class="custom-control-input" id="customSwitch3"
                        (change)="onRequiredChange($event)" />
                    <label class="custom-control-label" for="customSwitch3"></label>
                </div>
            </div>
            <ng-container  *ngTemplateOutlet="lockCheckbox; context: { isLocked: isLocked }"></ng-container>
            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Allow multi response checkbox (Template/Document - section) - Allow multi response")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" class="custom-control-input" id="allowMultiResponse" (change)="onMultiChoiceChange($event)"
                        [checked]="isMultiChoiceChecked" />
                    <label class="custom-control-label" for="allowMultiResponse"></label>
                </div>
            </div>

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Hide field label (Template/Document - section) - Hide label")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input [checked]="isLabelHide" type="checkbox" class="custom-control-input" id="hideLabel" (change)="hideLabel($event)" />
                    <label class="custom-control-label" for="hideLabel"></label>
                </div>
            </div>

            <hr class="mt-2 mb-1">

            <div class="form-group px-1 custum-dropdown-field-type">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Who select this option (Template/Document - section) - Who select this option")}}?</label>
                <ng-select [items]="selectRole" bindLabel="name" bindValue="id" [(ngModel)]="selectedRole" [readonly]="readonly"
                    [searchable]="searchable" [placeholder]='t("Field settings Select role - placeholder (Template/Document - section) - Select role")' [clearable]="false" (change)="onChangeRoleType($event)"> 
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div>
                                <div class="">
                                    <span class="">{{ item.name }}</span>
                                    <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.recipient }}</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
            </div>

            <div class="form-group px-1" *ngIf="isTagView === 0">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Field font size (Template/Document - section) - Font size")}}</label>
                <ng-select [items]="selectFontSize" #select_selectFontSize bindLabel="name" [(ngModel)]="selectedFontSize" [readonly]="readonly"
                    [searchable]="searchable" (change)="changeFontSize($event)" [clearable]="false"></ng-select>
            </div>
            <div class="form-group px-1" *ngIf="data['isFormBuilder'] === 1">
                <label class="col-form-label pt-0" for="name">{{t("Field settings Field column size (Template/Document - section) - Column size")}}</label>
                <ng-select [items]="selectColumnSize" bindLabel="name" bindValue="id" [(ngModel)]="selectedColumnSize" [readonly]="readonly"
                    [searchable]="searchable" [placeholder]='t("Field settings Select column size (Template/Document - section) - Select column size")' (change)="changeColumnSize($event)" [clearable]="false">
                </ng-select>
            </div>
        
            <hr class="mt-2 mb-2">

            <div class="form-group d-flex justify-content-between align-items-center px-1">
                <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field Conditional (Template/Document - section) - Conditional")}}</label>
                <div class="custom-control custom-control-primary custom-switch ">
                    <input type="checkbox" class="custom-control-input" id="Conditional" (change)="activeConditional($event)" [checked]="enable_conditional" />
                    <label class="custom-control-label" for="Conditional"></label>
                </div>
            </div>

            <div class="form-group px-1 mt-1 conditional-dropdown" *ngIf="enable_conditional">
                <div class="mt-1" >
                    <ng-select #conditional_fields_textField [compareWith]="selectedFeildFn" [closeOnSelect]="false" [multiple]="true" [items]="conditional_fields" bindLabel="name" bindValue="uuid" [(ngModel)]="selectedConditioanl" [readonly]="readonly"
                    [searchable]="true" placeholder="Select field" [clearable]="false" (change)="onSelectRelations($event)">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm" let-clear="clear">
                            <div>
                                <div class="d-flex">
                                    <div class="d-flex w-100 flex-column align-items-start justify-content-center">
                                        <span class="ng-value-label">{{ item.name }}</span>
                                        <span *ngIf="item.selected_field === SelectedFieldEnum.DroplistField || item.selected_field === SelectedFieldEnum.ListField" class="text-muted">({{item.field_name}})</span>
                                    </div>
                                    <span class="field-type-label">{{ item.role_name }}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <hr class="mt-2 mb-1">

            <div class="px-1 mt-2 mb-2">
                <div class="cursor-pointer mt-50 text-danger d-flex align-items-center">
                    <i data-feather="trash" [size]="16" class="me-50"></i>
                    <span class="align-text-bottom line-height-1" (click)="deleteSettings()">{{t("Delete button text (delete button) - delete")}}</span>
                </div>
            </div>
        </div>
        </ng-scrollbar>
    </div>
    <!-- / Multi Choice Settings View -->
        
    <!-- Document price settings -->
        <div id="multiChoiceFieldBox" *ngIf="data['selected_field'] === 'document_price'">
            <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="price-setting-scroll">
            <div>
                <label class="px-1 mb-1">{{t("auto-calculate and track the sum of any/all product tables within a document - (document price settings) - (Template/Document - section) - Here you can auto-calculate and track the sum of any/all product tables within a document or set a custom total amount. This sum will be displayed in: Documents, API and on Statistics")}}</label>

                <div class="form-group px-1">
                    <label class="col-form-label pt-0">{{t("Currency - label (general) - Currency")}}</label>
                    <ng-select [items]="currency" bindLabel="name" bindValue="id" [(ngModel)]="selectedCurrency" [clearable]="false">
                    </ng-select>
                </div>
                
                <div class="px-1 mt-2">
                    <label class="col-form-label pt-0 pb-0"> {{t("Product Table settings Product Table title (Template/Document) - Product Table")}} </label>
                    <label class="mb-0 mt-50">{{t("Document price table text (Template/Document - section) - Choose the tables to include in document price")}}</label>
                </div>

                <hr class="mt-2 mb-2">

                <div class="form-group px-1">
                    <label class="col-form-label pt-0" for="basicInput">{{t("Document price Custom price text (Template/Document - section) - Custom")}}</label>
                    <div class="input-group input-group-merge"> 
                        <input
                            type="number"
                            class="form-control"
                            placeholder="-"
                            aria-label="-"
                        />
                        <div class="input-group-append">
                            <span class="input-group-text">USD</span>
                        </div>
                    </div>
                </div>

                <div class="px-1 mt-2">
                    <label class="col-form-label pt-0 pb-0"> {{ t("Document price Grand Total in price text (Template/Document - section) - Grand Total") }} </label>
                    <h4 class="fw-bolder mb-0 mt-25 text-success">0,00 <span>USD</span></h4>
                </div>
            </div>
            </ng-scrollbar>
        </div>
    <!-- / Document price settings -->
</div>
    <ng-template #lockCheckbox let-isLocked="isLocked">
        <app-lock-field 
            type="field"
            [uuid]="data['uuid']"
        >
        </app-lock-field>
    </ng-template>
</ng-container>
